import { ChatDestinationVO } from '@repo/types'
import { SOURCE_TYPES } from './constants'

export const getDestinationDepartment = (destination?: ChatDestinationVO | null): string | undefined => {
  if (!destination) {
    return undefined
  }
  // @ts-expect-error
  return destination.infos.DEPARTMENT
}

export const getBrowser = (): string => {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Firefox')) {
    return 'Firefox'
  } else if (userAgent.includes('Edg')) {
    return 'Edge'
  } else if (userAgent.includes('Chrome') && !userAgent.includes('Chromium')) {
    return 'Chrome'
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari'
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera'
  } else {
    return 'Unknown Browser'
  }
}

export const isValidBrazilianPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.startsWith('55')
}

export const isReferral = (sourceType: string) => {
  return sourceType !== SOURCE_TYPES?.DEFAULT?.name && sourceType !== SOURCE_TYPES?.ECHO?.name
}

export const formatText = (text: string, limit: number): string => {
  return text.length > limit ? text.slice(0, limit).concat('...') : text
}

export const wait = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
